module.exports = __webpack_public_path__ + "static/img/10.b3598169.jpg";